<template>
  <div class="RadioColors">
    <div class="form-group">
      <label>Cor</label>
      <div class="row-radio">
        <div
          v-for="cor in colors"
          class="col-radio container">
          <button
            class="radioColor"
            :class="[cor, color === cor ? 'selected' : '' ]"
            @click.prevent="setColor(cor)"
          ></button>
        </div>
      </div>
    </div>
<!--    <p>COLOR SELECTED: {{ colorSelected }}</p>-->
  </div>
</template>

<script>
  export default {
    name: 'RadioColors',
    model: {
      prop: 'colorSelected',
      event: 'setColor'
    },
    props: {
      colorSelected: String
    },
    data () {
      return {
        colors: ['Primary', 'Success', 'Warning', 'Danger', 'Info']
      }
    },
    computed: {
      color: function () {
        return this.colorSelected
      }
    },
    methods: {
      setColor (cor) {
        this.$nextTick(() => {
          this.$emit('setColor', cor)
          // this.colorSelected = cor
        })
      }
    }
  }
</script>

<style scoped>
  .row-radio > div{
    text-align: center;
  }
  .radioColor{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: none;
  }

  .radioColor.Success {
    background-color: #67C23A;
  }
  .radioColor.Warning {
    background-color: #E6A23C;
  }
  .radioColor.Danger {
    background-color: #F56C6C;
  }
  .radioColor.Info {
    background-color: #909399;
  }
  .radioColor.Primary {
    background-color: #409EFF;
  }
  .radioColor.selected{
    border: 3px solid #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/Trg/RadioColors/RadioColors.vue